
const stateManager = require('../state/stateManager')
const jobsServer = require('../jobs/jobsServer')
const guidUtil = require('../../utils/guid/guidUtil.js');
const rmsApiProxyRetry = require('../../utils/api/rmsApiProxyRetry');
const terminalUtility = require('../../utils/domain/terminalUtility');

export function getNextOrderNumber()
{
    return stateManager.getStore().getState().orderNumber;
}

export function incrementOrderNumber()
{
    stateManager.getStore().getState().orderNumber += 1;

    jobsServer.addJob(guidUtil.generateGuid(), "Increment.Order.Number",
                      async ()=>
                      {
                            await rmsApiProxyRetry.post(`core/system/numberFountains/posOrderNumber/${terminalUtility.getTerminalCode()}/current`)
                      }, false);
}